module.exports = __webpack_public_path__ + "static/img/dll.9d21b441.png";